import { render, staticRenderFns } from "./personal-information.page.vue?vue&type=template&id=21b34cb9&"
import script from "./personal-information.page.vue?vue&type=script&lang=ts&"
export * from "./personal-information.page.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports